/**
 * @description: 将Gson格式转为object
 * @param {*} data
 * @return {*}
 */
export function FromGson(data) {
  if (data['1.0']) {
    delete data['1.0'];
  }
  for (let item in data) {
    // data[item] = JSON.parse(data[item].replace(/\\+"/g, ''));
    data[item] = JSON.parse(data[item]);
    if(data[item] && data[item].volume) {
      delete data[item].volume;
    }
  }
  return data;
}

/**
 * @description: 将路径转为有效的aws下载url
 * @param {*} url
 * @return {*}
 */
export function formatAwsUrl(url) {
  return url.includes('https://')
    ? url
    : 'https://resource.3uplay.com/sys-feed/' + url;
}
